import _ from "lodash";
import gsap from "gsap";
export default class Atc {
  constructor() {
    this.form = document.querySelector(".add-to-cart-form");
    this.currency = document.querySelector("body").dataset.currency;
    this.valid = false;
    this.product_id = this.form.dataset.id;
    this.option1 = false;
    this.option2 = false;
    this.option3 = false;
    this.carezza = document.querySelector(".carezza-charm");
    this.carezza_total = 0;
    this.carezza_price = 0;
    this.carezza_els = [];
    this.gallery_url = this.form.dataset.gallery;
    this.gallery_el = document.querySelector(".js-gallery-container");
    this.qty = false;
    this.button = document.querySelector('[data-js="product-atc"]');
    this.engraving_toggl = document.querySelector('[data-js="customize-checkbox"]');
    this.open_count = 0;
    this.price_el = document.querySelector('.ppp-price');
    this.price = parseFloat(this.price_el.dataset.price);
    this.mobile_price = document.querySelector('.js-mobile-price');
    this.quantity_buttons = document.querySelectorAll(".quantity-option");
    this.arrowButton = document.querySelector(
      "[data-js='customize-arrow-mobile']",
    );
  }

  init() {
    console.log(this.price);
    this.getEls();
    this.getValues();
    this.validate();
    if (this.valid && this.engraving_toggl && window.innerWidth < 1024) {
      this.open_count = 1
    }
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (this.open_count < 1) {
        this.submit();
      } else {
        this.open_count = 0
      }
    });
    this.form.addEventListener("input", (e) => {
      e.preventDefault();
      this.validate();
    });


  }

  setPrice() {
    console.log(this.price)
    const price = (this.price + this.carezza_price).toFixed(2) + " " + this.currency;
    this.price_el.innerHTML = price;
    this.mobile_price.innerHTML = price;
  }


  update(url) {
    const galleryElChildren = this.gallery_el.children;

    gsap.to(galleryElChildren, {
      opacity: 0,
      stagger: 0.2,
      ease: "power2.inOut",
      onComplete: () => {
        fetch(url)
          .then((response) => {
            // The API call was successful!
            return response.text();
          })
          .then((html) => {
            this.gallery_el.innerHTML = html;

            const galleryElChildren = this.gallery_el.children;

            gsap.set(galleryElChildren, {
              opacity: 0,
            });

            gsap.to(galleryElChildren, {
              opacity: 1,
              stagger: 0.2,
              ease: "power2.inOut",
            });
          })
          .catch((err) => {
            // There was an error
            console.warn("Something went wrong.", err);
          });
      },
    });
  }

  getEls() {
    const check1 = document.querySelector(".option1");
    if (check1) {
      const els = document.querySelectorAll(".option1");
      els.forEach((el) => {
        el.addEventListener("change", (e) => {
          const val = document.querySelector(".option1:checked");
          const val2 = document.querySelector("#option2").value;
          const variant = val.value + "-" + val2;
          const url =
            this.gallery_url +
            "?id=" +
            this.product_id +
            "&variant=" +
            variant;

          this.update(url);
        });
      });
    } else {
      const el = document.querySelector("#option1");

      el.addEventListener("change", (e) => {
        const val = document.querySelector("#option1");
        const val2 = document.querySelector("#option2").value;
        const option = el.options[el.selectedIndex];
        if (option.dataset.price) {
          const cleaned = option.dataset.price.replace(/[^\d,.-]/g, '').replace(',', '.');
          this.price = parseFloat(cleaned)
          this.setPrice()
        }
        const url =
          this.gallery_url +
          "?id=" +
          this.product_id +
          "&variant=" +
          val.value +
          "-" +
          val2;
        this.update(url);
      });
    }
  }


  getValues() {
    console.log("getValues")
    const qty = document.querySelector("#product-quantity");
    if (qty) {
      this.qty = qty.value;
    } else {
      let val = document.querySelector(".quantity-option:checked");
      this.qty = val ? val.value : false;
    }
    this.option2 = document.querySelector("#option2").value;
    if (this.option2) {
      const label = document.querySelector('.option2-label')
      if (label) {
        label.classList.remove("invalid")

      }
    }
    const check1 = document.querySelector(".option1");
    const check3 = document.querySelector(".option3");
    if (check3) {
      const val = document.querySelector(".option3:checked");
      this.option3 = val ? val.value : false;
      if (val && val.dataset.price) {
        const cleaned = val.dataset.price.replace(/[^\d,.-]/g, '').replace(',', '.');
        this.price = parseFloat(cleaned)
        this.setPrice()
      }

    } else {
      this.option3 = document.querySelector("#option3").value;
    }
    if (check1) {
      const val = document.querySelector(".option1:checked");
      this.option1 = val ? val.value : false;
    } else {
      this.option1 = document.querySelector("#option1").value;
    }
  }

  submit() {
    this.validate();
    if (this.valid) {
      this.addToCart();
      if (this.engraving_toggl && window.innerWidth < 1024) {
        this.open_count = 1
        this.engraving_toggl.checked = false
        this.arrowButton.click()
      }
    }
  }

  setCarezza() {
    if (this.carezza) {
      const inputs = this.carezza.querySelectorAll("input");
      inputs.forEach((input) => {
        input.addEventListener("change", (e) => {

          this.setCarezzaTotal(e);
        });
      });
    }
  }

  setCarezzaTotal(e) {
    // limite 5 selection 2 -- posso avere max 3 
    const el = document.querySelector("#option1")
    var text = parseInt(el.options[el.selectedIndex].dataset.max);
    const limit = text;
    const target = document.querySelector(".maxcharm");
    target.innerHTML = text;
    this.carezza_els = this.carezza.querySelectorAll("select");
    this.carezza_total = Array.from(this.carezza_els).reduce((total, el) => {
      return total + (parseFloat(el.value) || 0);
    }, 0);
    this.carezza_price = Array.from(this.carezza_els).reduce((total, el) => {
      return total + (parseFloat(el.dataset.price * el.value) || 0);
    }, 0);
    console.log(this.carezza_price)

    this.carezza_els.forEach((el) => {
      const options = el.querySelectorAll("option");
      options.forEach((option) => {
        if (parseFloat(option.value) > limit - this.carezza_total) {
          option.disabled = true;
        } else {
          option.disabled = false;
        }
      });
    });
    this.setPrice()



  }
  validate() {
    this.getValues();
    if (this.carezza) {
      this.setCarezzaTotal();
    }
    if (this.quantity_buttons) {
      let val = document.querySelector(".quantity-option:checked");
      if (val) {
        const cleaned = val.dataset.price.replace(/[^\d,.-]/g, '').replace(',', '.');
        this.price = parseFloat(cleaned)
        this.setPrice()

      }
    }
    //console.log(this.option1, this.option2, this.option3, this.qty)
    const r = this.option1 && this.option2 && this.option3 && this.qty;
    if (r) {
      this.valid = true;
      this.button.innerHTML = this.button.dataset.valid;
    } else {
      this.valid = false;
      this.button.innerHTML = this.button.dataset.invalid;
    }
  }

  addToCart() {
    this.getValues();
    const qty = this.qty;
    const variants = JSON.parse(this.form.dataset.variants);
    // console.log(variants);
    const variant = variants.find(variant =>
      variant.option1 === this.option1 &&
      variant.option2 === this.option2 &&
      variant.option3 === this.option3
    );

    let obj = {
      id: variant.id,
      quantity: parseInt(qty)
    };
    if (this.carezza_total > 0) {
      obj["carezza"] = [];
      this.carezza_els.forEach((el) => {
        obj["carezza"].push({
          id: el.dataset.id,
          title: el.dataset.title,
          quantity: parseInt(el.value)
        });
      });
    }

    console.log(obj)

    if (this.engraving_toggl) {
      const font = document.querySelector(".engraving-font-input:checked").value;
      const inputs = document.querySelectorAll('.engraving-message-line')
      const engraving_price = document.querySelector('#engraving-price').value;
      let message;
      let str = [];
      inputs.forEach((input) => {
        if (input.value) {
          str.push(input.value)
        } else {
          str.push(" ")
        }
      })
      if (str.length > 0 && this.engraving_toggl.checked) {
        message = str.join("|")
        obj["message"] = message
        obj["engraving"] = font
        obj["engraving_price"] = engraving_price
      }
    }

    this.postData(this.form.dataset.url, obj).then((data) => {
      if (typeof gtag !== "undefined" && variant) {
        gtag("event", "add_to_cart", {
          items: [variant.google],
        });
        gtag("event", "add", {
          event_category: "cart",
        });
      }
      this.form.reset()
      this.validate();
      window.dispatchEvent(new CustomEvent("add-to-cart"));
    });
  }

  async postData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data),
    });
    return response.json();
  }
}
